// index.jsx
import React from "react";
import ReactDOM from "react-dom/client";
// App-wide UI font. Each weight only downloads when text actually uses it.
import "@fontsource/atkinson-hyperlegible-next/400.css";
import "@fontsource/atkinson-hyperlegible-next/400-italic.css";
import "@fontsource/atkinson-hyperlegible-next/500.css";
import "@fontsource/atkinson-hyperlegible-next/600.css";
import "@fontsource/atkinson-hyperlegible-next/700.css";
import "./index.css";
import "katex/dist/katex.min.css";
import App from "./App";
import ThemeProvider from "./ui/theme";
import { ConsentProvider } from "./consent/ConsentContext";

/* ─── Render tree ────────────────────────────────────────────── */
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <ThemeProvider>
      <ConsentProvider>
        <App />
      </ConsentProvider>
    </ThemeProvider>
  </React.StrictMode>,
);
